'use client';

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from '@/components/ui/carousel';
import { Languages } from '@/lib/dictionaries';
import { useFetchBannersQuery } from '@/slice/banners';
import Image from 'next/image';
import React from 'react';
import '@/app/input.css';

function MainBanner({ lang }: { lang: Languages }) {
  const { data, isLoading } = useFetchBannersQuery('home-top');

  const handleClickLink = (banner: any) => {
    window.location.href = `twitter://status?id=${banner.ctaLink[lang].split('/').pop()}`;

    setTimeout(() => {
      if (!document.hidden) {
        window.open(banner.ctaLink[lang]);
      }
    }, 500);
  };

  return (
    <div className="py-10 max-w-[1200px] mx-auto w-[calc(100%-48px)]">
      <Carousel opts={{ loop: true }}>
        <CarouselContent>
          {!isLoading &&
            data &&
            data.length > 0 &&
            data.map((banner: any, index: number) => (
              <CarouselItem key={`banner-${banner.id}`}>
                <div className="flex flex-col md:flex-row gap-4 justify-center">
                  <div className="flex flex-row justify-center gap-4">
                    <div className="flex items-start">
                      <span className="font-bold text-3xl text-[#FF7395]">
                        {(index + 1).toString().padStart(2, '0')}
                      </span>
                    </div>
                    <div className="w-[309px] h-[309px] md:w-[400px] md:h-[400px] relative">
                      <Image
                        src={banner.image[lang].url}
                        alt={banner.campaignTitle[lang]}
                        fill
                      />
                    </div>
                  </div>
                  <div className="flex flex-col-reverse">
                    <div className="flex flex-row gap-4">
                      <div className="w-[60px] h-[66px] relative shrink-0 rounded-full overflow-hidden">
                        <Image
                          src={banner.thumbnail.url}
                          alt="thumbnail"
                          fill
                        />
                      </div>
                      <div className="flex flex-col flex-1">
                        <p className="md:text-xl sm:text-base font-bold text-[#FF7395]">
                          {banner.achievementTitle[lang]}
                        </p>
                        <p className="md:text-2xl sm:text-xl font-bold text-[#333333]">
                          {banner.campaignTitle[lang]}
                        </p>
                        <button
                          className="md:text-base font-bold text-left text-[#333333]"
                          onClick={() => handleClickLink(banner)}
                        >
                          {banner.ctaText[lang]}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
        </CarouselContent>
        <CarouselDots className="pt-10" />
      </Carousel>
    </div>
  );
}

export default MainBanner;
